import "./App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import HeaderAr from "./components/HeaderAr";
import Footer from "./components/Footer";
import FooterAr from "./components/FooterAr";
import WhatsAppButton from "./components/WhatsAppButton";
import CookieConsent from "./components/CookieConsent";

const Home = lazy(() => import("./pages/Home"));
const HomeAr = lazy(() => import("./pages/HomeAr"));
const Services = lazy(() => import("./pages/Services"));
const ServicesAr = lazy(() => import("./pages/ServicesAr"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogAr = lazy(() => import("./pages/BlogAr"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Calculator = lazy(() => import("./pages/Calculator"));
const CalculatorAr = lazy(() => import("./pages/CalculatorAr"));
const Contact = lazy(() => import("./pages/Contact"));
const ContactAr = lazy(() => import("./pages/ContactAr"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const Terms = lazy(() => import("./pages/Terms"));
const Admin = lazy(() => import("./pages/Admin"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <CookieConsent />
          <Routes>
            {/* Admin routes without header/footer */}
            <Route path="/admin/login" element={<Suspense fallback={<div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading...</div>}><AdminLogin /></Suspense>} />
            
            {/* Arabic routes with Arabic header/footer */}
            <Route path="/ar/*" element={
              <>
                <HeaderAr />
                <Suspense fallback={<div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>...جاري التحميل</div>}>
                  <Routes>
                    <Route path="/" element={<HomeAr />} />
                    <Route path="/services" element={<ServicesAr />} />
                    <Route path="/blog" element={<BlogAr />} />
                    <Route path="/calculator" element={<CalculatorAr />} />
                    <Route path="/contact" element={<ContactAr />} />
                  </Routes>
                </Suspense>
                <FooterAr />
                <WhatsAppButton />
              </>
            } />

            {/* Main English routes with header/footer */}
            <Route path="/*" element={
              <>
                <Header />
                <Suspense fallback={<div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading...</div>}>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:postId" element={<BlogPost />} />
                    <Route path="/calculator" element={<Calculator />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/admin" element={<Admin />} />
                  </Routes>
                </Suspense>
                <Footer />
                <WhatsAppButton />
              </>
            } />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
